if (!customElements.get('quickbuy-variant-radios')) {
  customElements.define(
    'quickbuy-variant-radios',
    class QuickBuyVariantRadios extends VariantRadios {
      constructor() {
        super()

        this.dataset.updateUrl = false
        this.dataset.updateSwatch = false
        this.dataset.updateVariantTitle = true

        this.isBundle = this.closest('.js-bundle-product-card') !== null

        this.setupShowMoreButton()
      }

      onVariantChange() {
        this.updateOptions()
        this.updateMasterId()
        this.removeErrorMessage()
        this.updateVariantStatuses()

        if (!this.currentVariant) {
          this.setUnavailable()
        } else {
          this.updateATCButton()
          this.updateVariantInput()
          if (this.isBundle) this.updateProductMedia()
          this.updateProductCardMedia()
        }
      }

      showOrHideInputs() {
        const productFormTop = this.quickBuyOptions.offsetTop
        const isActive = this.quickBuyOptions.classList.contains('active')
        let hideCount = 0

        function isOnTopLine(element) {
          const elementTop = element.offsetTop
          return elementTop - productFormTop < 15
        }

        this.selectors.forEach((selector) => {
          if (!isActive && !isOnTopLine(selector)) {
            selector.style.display = 'none'
            hideCount++
          } else {
            selector.style.display = 'block'
          }
        })

        if (!isActive) {
          if (hideCount === 0) {
            this.showMoreButton.style.display = 'none'
          } else {
            this.showMoreButton.style.display = 'block'
            if (!isOnTopLine(this.showMoreButton)) {
              // get last input still visible
              const lastVisibleInput = [...this.selectors]
                .reverse()
                .find(
                  (selector) => selector.style.display === 'block' && selector.classList.contains('sr-only') === false
                )
              if (lastVisibleInput) {
                lastVisibleInput.style.display = 'none'
              }
            }
          }
        }

        this.quickBuyOptions.classList.remove('max-h-6.25', 'opacity-0')
      }

      setupShowMoreButton() {
        // Initialize show more button
        this.showMoreButton = this.querySelector('.js-show-more-variants')
        this.quickBuyOptions = this.querySelector('.js-quickbuy-variant-picker-options')
        if (!this.showMoreButton) return

        this.showMoreButton.addEventListener('click', this.toggleMoreVariants.bind(this))
        this.selectors = this.quickBuyOptions.querySelectorAll('input[type="radio"].swatch-radio, label')

        this.showOrHideInputs()
      }

      updateProductCardMedia() {
        if (!this.currentVariant.featured_image) return

        const productCard = this.closest('.js-product-card, .js-bundle-product-card, .js-upsell-product-card')
        const activeMedia = productCard.querySelector('img.active')

        const newMedia = productCard.querySelector(`[data-variant-id="${this.currentVariant.id}"]`)

        if (!newMedia) return

        activeMedia.classList.remove('active')
        newMedia.classList.add('active')
      }

      updateOptions() {
        const quickBuyOptions = Array.from(this.querySelectorAll('.js-quickbuy-variant-picker-options'))
        this.options = quickBuyOptions.map((quickBuyOption) => quickBuyOption.querySelector('input:checked')?.value)
      }

      updateVariantInfo() {
        const variantTitle = this.querySelector('.js-quickbuy-variant-title')
        const metafield = variantTitle.getAttribute('metafield')
        if (metafield) {
          const variantNew = document.querySelector(`[data-product-form-id=${this.dataset.productFormId}`)
          const newSpan = variantNew.querySelector('.js-quickbuy-new')
          if (metafield.includes(this.currentVariant.title.toLowerCase()) && this.currentVariant.title !== 'Chill') {
            newSpan.innerHTML = '&nbsp;*(NEW)'
          } else {
            newSpan.innerHTML = ''
          }
        }
        variantTitle.innerHTML = this.currentVariant.title
      }

      updateVariantInput() {
        const productForms = document.querySelectorAll(`#${this.dataset.productFormId}, #product-form-installment`)

        productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]')

          input.value = this.currentVariant.id
          input.dispatchEvent(new Event('change', { bubbles: true }))
        })

        this.updateVariantInfo()
      }

      toggleMoreVariants({ target }) {
        target.closest('.js-quickbuy-variant-picker-options').classList.toggle('active')
        this.showOrHideInputs()
      }
    }
  )
}
